import type { AccessPair } from '@/shared/lib'

/** `/v1/clients/**` — ресурс менеджера, модификатора не принимает; клиенту `403`. */
export const CLIENTS_ACCESS: AccessPair = { own: 'manager.clients.view' }

/**
 * `GET /v1/clients/stats` — статистика по клиентам менеджера. Полный вид без `?client=` и разрез
 * по одному клиенту с `?client=` закрыты одним правом (`manager.stats.view`): бэк отвечает `403`
 * этим же правом и на модификатор (`ACTING_AS_FORBIDDEN`). Поэтому `own` и `onBehalf` совпадают —
 * пункт меню `/stats` (режим `own`) остаётся у менеджера, а вкладка профиля даёт разрез по клиенту
 * (режим `client`). `accepts` не задан: кроме `client` ручка модификатор не принимает.
 */
export const CLIENT_STATS_ACCESS: AccessPair = {
  own: 'manager.stats.view',
  onBehalf: 'manager.stats.view',
}

/** `GET /v1/clients/debts` — долги клиентов менеджера. */
export const CLIENT_DEBTS_ACCESS: AccessPair = { own: 'manager.debts.view' }
